import {Auth, PasswordResetForm} from '..'

export default function PasswordReset() {
  return (
    <Auth title="Forgot your password?" backTo="/login">
      <PasswordResetForm />
    </Auth>
  )
}
